module.exports = __webpack_public_path__ + "img/discord_icon.a6480f55.png";